import React from "react";
import {Box, CircularProgress} from "@mui/material";
import logo from "/assets/imgs/logo.png";

type InitAppProps = {
    mt?: string
}


const InitializeApp = ({mt}: InitAppProps) => {
    const mtx = mt ? mt : "40vh";
    return <Box sx={{mt: mtx, ml: "auto", mr: "auto", textAlign: "center"}}>
        <img alt={"logo"} width={65} src={logo}/>
        <Box>
            <CircularProgress/>
        </Box>
    </Box>
}
export default InitializeApp;
